import { memo, useDeferredValue } from "react";
import ReactMarkdown from "react-markdown";

import WPLoader from "../../packages/WPLoader";

import { buildDocumentationHeaderId } from "./documentationApiHelpers";
import IntroductionPage from "./IntroductionPage";

import { INTRODUCTION_TAB } from "../../constants/LicenseManagement.constants";

const ALLOWED_URL_PROTOCOL_REGEX = /^(https?:|data:|\/|\.?\/)/i;

const allowDocumentationUrl = (url) => {
  if (!url) {
    return "";
  }

  return ALLOWED_URL_PROTOCOL_REGEX.test(url) ? url : "";
};

const DocumentationContent = ({
  selectedLicenseTabId,
  setSelectedLicenseTabId,
  userAssignedLicenseTabIds,
  userAccessibleLicenseTabIds,
  markdownContent,
}) => {
  const isIntroductionPageSelected =
    selectedLicenseTabId === INTRODUCTION_TAB.id;
  const deferredMarkdownContent = useDeferredValue(markdownContent);
  const isMarkdownRenderPending = deferredMarkdownContent !== markdownContent;

  const renderHeadingWithId =
    (Tag) =>
    ({ children, ...props }) => {
      const headingText = Array.isArray(children)
        ? children.join("")
        : String(children || "");
      const headingId = buildDocumentationHeaderId(headingText);

      return (
        <Tag id={headingId} {...props}>
          {children}
        </Tag>
      );
    };
  const renderH2Heading = renderHeadingWithId("h2");
  const renderH3Heading = renderHeadingWithId("h3");
  const renderAnchor = ({ href, children, ...props }) => {
    // for TOC (Table of Contents) in-page anchors
    const isInPageAnchor = typeof href === "string" && href.startsWith("#");

    if (isInPageAnchor) {
      return (
        <a href={href} {...props}>
          {children}
        </a>
      );
    }

    // for external links
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  };

  return (
    <div className="licensed-documentation__main-content">
      {isIntroductionPageSelected ? (
        <IntroductionPage
          userAssignedLicenseTabIds={userAssignedLicenseTabIds}
          userAccessibleLicenseTabIds={userAccessibleLicenseTabIds}
          setSelectedLicenseTabId={setSelectedLicenseTabId}
        />
      ) : isMarkdownRenderPending ? (
        <WPLoader isFocus={false} />
      ) : (
        <ReactMarkdown
          urlTransform={allowDocumentationUrl}
          components={{
            h2: renderH2Heading,
            h3: renderH3Heading,
            a: renderAnchor,
          }}
        >
          {deferredMarkdownContent}
        </ReactMarkdown>
      )}
    </div>
  );
};

export default memo(DocumentationContent);
